import { RuleGroup } from "@gymflow/types";


export type ClassRules = ReturnType<
  typeof rulesHelper.mapRuleGroupToClassRules
>;
export type AppointmentRules = ReturnType<
  typeof rulesHelper.mapRuleGroupToAppointmentRules
>;
export type MembershipRules = ReturnType<
  typeof rulesHelper.mapRuleGroupToMembershipRules
>;
export type AccessRules = ReturnType<
  typeof rulesHelper.mapRuleGroupToAccessRules
>;

export const rulesHelper = {
  mapRuleGroupToClassRules: (ruleGroup?: RuleGroup) => {
    const advancedBookingsRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "BOOKING_LIMIT_WINDOW",
    )?.bookingRule;
    const bookingNoticeRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "BOOKING_NOTICE_PERIOD",
    )?.bookingNoticePeriodRule;
    const concurrentBookingRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "CONCURRENT_BOOKING",
    )?.concurrentBookingRule;
    const bookingCancellationRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "BOOKING_CANCELLATION_WINDOW",
    )?.bookingCancellationRule;
    const bookingLimitRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "BOOKING_LIMIT_PER_CUSTOMER",
    )?.bookingLimitRule;
    const noShowRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "NO_SHOW_FEE",
    )?.noShowFeeRule;
    return {
      advancedBookingsRule,
      bookingNoticeRule,
      concurrentBookingRule,
      bookingCancellationRule,
      bookingLimitRule,
      noShowRule,
    } as const;
  },
  mapRuleGroupToAppointmentRules: (ruleGroup?: RuleGroup) => {
    const advancedBookingsRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "BOOKING_LIMIT_WINDOW",
    )?.bookingRule;
    const bookingNoticeRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "BOOKING_NOTICE_PERIOD",
    )?.bookingNoticePeriodRule;
    const rescheduleNoticeRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "RESCHEDULE_NOTICE_PERIOD",
    )?.rescheduleNoticePeriodRule;
    const concurrentBookingRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "CONCURRENT_BOOKING",
    )?.concurrentBookingRule;
    const bookingCancellationRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "BOOKING_CANCELLATION_WINDOW",
    )?.bookingCancellationRule;
    const bookingLimitRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "BOOKING_LIMIT_PER_CUSTOMER",
    )?.bookingLimitRule;
    const noShowRule = ruleGroup?.ruleClubList.find(
      (r) => r.ruleType === "NO_SHOW_FEE",
    )?.noShowFeeRule;
    return {
      advancedBookingsRule,
      bookingNoticeRule,
      concurrentBookingRule,
      bookingCancellationRule,
      bookingLimitRule,
      noShowRule,
      rescheduleNoticeRule,
    } as const;
  },
  mapRuleGroupToMembershipRules: (ruleGroup: RuleGroup) => {
    const subscriptionCancellationRule = ruleGroup.ruleClubList.find(
      (r) => r.ruleType === "SUBSCRIPTION_CANCELLATION",
    )!.subscriptionCancellationRule!;

    const subscriptionMembershipChangeRule = ruleGroup.ruleClubList.find(
      (r) => r.ruleType === "SUBSCRIPTION_MEMBERSHIP_CHANGE",
    )!.subscriptionMembershipChangeRule!;

    return {
      subscriptionCancellationRule,
      subscriptionMembershipChangeRule,
    } as const;
  },
  mapRuleGroupToAccessRules: (ruleGroup: RuleGroup) => {
    const checkoutRule = ruleGroup.ruleClubList.find(
      (r) => r.ruleType === "AUTOMATIC_CHECK_OUT",
    )!.checkOutRule!;
    return { checkoutRule } as const;
  },
};
